<template>
<div>
  <van-field
    :label="label"
    :placeholder="placeholder"
    v-model="showVal"
    is-link
    readonly
    :rules="rules"
    :required="required"
    :disabled="disabled"
    @click="handleClick"
  />
  <van-action-sheet
    :title="title"
    v-model="show"
    :actions="pickList"
    cancel-text="取消"
    close-on-click-action
    @select="handleItemsSelect"
    @cancel="show=false"
  />
</div>
</template>

<script>

export default {
  props: {
    value: String,
    name: String,
    title: String,
    type: String,
    label: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    }    
  },
  model: {
    event: 'input',
  },
  data() {
    return {
      showVal: '',
      id: '',
      show: false,
    }
  },
  watch: {
    name(val) {
      this.showVal = val
    },
    items(val) {
      this.pickList = val
    }
  },
  created() {
    this.showVal = this.name
    this.pickList = this.items
  },
  methods: {
    handleClick() {
      if(this.disabled) return
      this.show = true
    },
    handleItemsSelect(customer) {
      const {name, id, item} = customer
      this.showVal = name
      this.id = id
      this.$emit('input', id)
      this.$emit('selected', name, item)
    },
  },
}
</script>

<style>

</style>